import React, { useState } from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';

const AddButton = ({ label = '', onPress, iconSize = 'S', style, textStyle, iconColor = '#2d77d0' }) => {
  const [focused, setFocused] = useState(false);

  return (
    <TouchableOpacity
      onPress={onPress}
      onMouseEnter={() => setFocused(true)}
      onMouseLeave={() => setFocused(false)}
      style={[styles.button, focused && styles.buttonFocused, style]}>
      <Text style={[styles.text, focused && styles.textFocused, textStyle]}>
        {/* <Icons.AddIcon size={iconSize} color={iconColor} /> */}+{label ? ` ${label}` : ''}
      </Text>
    </TouchableOpacity>
  );
};

export default AddButton;

const styles = StyleSheet.create({
  button: {
    borderColor: '#cbd5e1',
    borderWidth: 1,
    borderRadius: 16,
    paddingVertical: 3,
    paddingHorizontal: 12,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease'
  },
  buttonFocused: {
    backgroundColor: '#f0f7ff',
    borderColor: '#2d77d0'
  },
  text: {
    color: '#2d77d0',
    fontWeight: '600',
    fontSize: 13,
    paddingBottom: 2
  },
  textFocused: {
    color: '#1a56b6'
  }
});
